/**
 * What the 7R graph's target line stands for (OE-265). With no reps ticked it is the company's own
 * target; with reps ticked it is the sum of THOSE reps' targets, which need not equal the company
 * target even when every rep is ticked. The label says which, so the two views are not mistaken
 * for one another.
 */
export function targetLabel(opts: { companyView: boolean; selectedReps: number }): string {
    const { companyView, selectedReps } = opts;
    if (selectedReps > 0) return `Target of ${selectedReps} selected rep${selectedReps === 1 ? '' : 's'}`;
    return companyView ? 'Company target' : 'Your target';
}
